import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import {
  changeProjetoValue,
  loadHistoricoAvaliacoes,
  saveProjeto,
} from '../../../../../store/modules/ProjetoActions';

import { Col } from '../../../../../components/Col';
import { CustomCard } from '../../../../../components/CustomCard';
import { CustomTextArea } from '../../../../../components/CustomTextArea';
import { GenericProjectCard } from '../../../../../components/GenericProjectCard';
import { Row } from '../../../../../components/Row';
import { getStepSlug } from '../../../../../library/ProjectSteps';
import { projectEdit } from '../../../../../library/Routes';
import { openModal } from '../../../../../store/modules/ModalActions';
import { etapaIsUnlocked } from '../../../../../utils/ProjetoUtils';
import SnackbarUtils from 'utils/SnackbarUtils';
import { PROJECT_STATUS_PENDENTE } from 'library/ProjectStatus';

class Etapa2_1Card2 extends GenericProjectCard {
  stepIndex = 2;

  validationResults = [false];

  constructor(props) {
    super(props);

    this.state = {
      ...(this.state || {}),
      descricaoObjetivoExpedicaoChanged: false,
      sending: false,
    };

    this.setValue = this.setValue.bind(this);
    this.toSubmit = this.toSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadHistoricoAvaliacoes(this.props.projeto.id, this.stepIndex);
  }

  descricaoObjetivoExpedicaoIsValid() {
    return this.props.projeto.descricaoObjetivoExpedicao
      ? this.props.projeto.descricaoObjetivoExpedicao.length > 0
      : false;
  }

  changeSendingStatus(status) {
    this.setState({
      ...this.state,
      sending: status,
    });
  }

  toSubmit() {
    if (!this.itemsAreValid(this.validationResults)) {
      return;
    }
    this.changeSendingStatus(true);
    let avaliacao =
      this.props.projeto.avaliacoes.length > this.stepIndex + 1
        ? this.props.projeto.avaliacoes[this.stepIndex]
        : {};
    avaliacao.etapa = this.stepIndex;
    avaliacao.status = PROJECT_STATUS_PENDENTE;
    const data = {
      id: this.props.projeto.id || null,
      idUsuario: this.props.projeto.idUsuario,
      descricaoPerguntaExploratoria:
        this.props.projeto.descricaoPerguntaExploratoria,
      descricaoTerritorioInvestigado:
        this.props.projeto.descricaoTerritorioInvestigado,
      descricaoObjetivoExpedicao: this.props.projeto.descricaoObjetivoExpedicao,
      consultaPublica: this.props.projeto.consultaPublica,
      avaliacao,
    };
    this.props.saveProjeto(
      data,
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.props.languageValues.successCadastrarEtapa2_1,
          options: {
            variant: 'success',
          },
        });
        this.changeSendingStatus(false);
        this.props.history.push(
          projectEdit.getURLWithParams(
            this.props.projeto.id,
            getStepSlug(this.stepIndex + 1)
          )
        );
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.erroCadastrarEtapa2_1,
          options: {
            variant: 'error',
          },
        });
        this.changeSendingStatus(false);
      }
    );
  }

  render() {
    this.validationResults =
      !etapaIsUnlocked(this.stepIndex, this.props.projeto.avaliacoes) ||
      this.state.sending
        ? [false]
        : [this.descricaoObjetivoExpedicaoIsValid()];
    return (
      <CustomCard
        stepIndex={this.stepIndex}
        titleHint={this.props.languageValues.hintEtapa2_1}
        CardHeaderPropTypes={{
          title: this.props.languageValues.etapa2_1,
        }}
        sending={this.state.sending}
      >
        <form
          className={this.getFormClasses(this.state.sending)}
          onSubmit={(event) => {
            event.preventDefault();
            this.toSubmit(event);
          }}
        >
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextArea
                label={this.props.languageValues.descricaoObjetivoExpedicao}
                name='descricaoObjetivoExpedicao'
                value={this.props.projeto.descricaoObjetivoExpedicao || ''}
                onChange={this.setValue}
                error={!this.descricaoObjetivoExpedicaoIsValid()}
                counter={true}
                maxSize={2000}
                disabled={
                  this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          {this.getActionsRow([
            [
              null,
              this.getHistoryButton(
                this.props.languageValues.reviewButton,
                this.props.languageValues.etapa2_1,
                this.props.projeto.historico &&
                  this.props.projeto.historico[this.stepIndex]
                  ? this.props.projeto.historico[this.stepIndex]
                  : [],
                this.stepIndex,
                this.props.openModal
              ),
            ],
            [
              this.getPreviousButton(!this.state.sending),
              this.getFinalyButton(
                this.props.lockedAllFields ||
                  !this.itemsAreValid(this.validationResults),
                this.toSubmit
              ),
            ],
          ])}
        </form>
      </CustomCard>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProjetoValue,
      saveProjeto,
      loadHistoricoAvaliacoes,
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Etapa2_1Card2));
